import { environment } from "../../environments/environment";

/**
 * Pad a single-digit day/month/number value with a leading zero.
 * Returns the original value unchanged when it is not a single character.
 *
 * Canonical extraction of the byte-identical `checkDate(str)` helper that was
 * duplicated across multiple components.
 */
export function checkDate(str) {
  const data = str;
  if (data.toString().length === 1) {
    return "0" + data;
  } else {
    return data;
  }
}

/**
 * Pad a single-digit value with a leading zero, coercing the result to a
 * string when padding is applied.
 *
 * Canonical extraction of the byte-identical strict-equality (`===`) variant of
 * the `chkLength(data)` helper duplicated across multiple components. The
 * loose-equality (`==`) variants are intentionally left untouched as they are
 * not byte-identical to this canonical version.
 */
export function chkLength(data) {
  if (data.toString().length === 1) {
    return "0" + data.toString();
  } else {
    return data;
  }
}

/**
 * Resolve the phone input mask for a given phone country code, falling back to
 * the component's resolved country code when no explicit code is supplied.
 *
 * Canonical extraction of the byte-identical `setMobilePhoneMask(phoneCode)`
 * helper. The instance property `this.testCountryCode` is passed in explicitly
 * so this stays a pure function with no `this` dependency.
 */
export function setMobilePhoneMask(phoneCode, testCountryCode) {
  let mask = "";
  if (phoneCode && phoneCode === "+1") {
    mask = environment.usPhoneMask;
  } else if (phoneCode && phoneCode === "+91") {
    mask = environment.indiaPhoneMask;
  }
  if (!mask) {
    if (testCountryCode === "US") {
      mask = environment.usPhoneMask;
    } else {
      mask = environment.indiaPhoneMask;
    }
  }
  return mask;
}
